<template>
  <div class="la-wrapper">
    <div class="d-flex flex-column flex-md-row la-row-white">
      <v-col cols="12" md="5" class="la-flex">
        <div class="la-pageTitle">
          {{ $t('readerDescTitle') }}
        </div>
        <p class="la-pageDesc">
          {{ $t('readerDesc') }}
        </p>
      </v-col>
      <v-col cols="12" md="6">
        <div style="display: flex; position: relative" v-if="!playVideo">
          <img class="la-videoBackground" src="/assets/video-bg.png" alt="chimege reader instruction video" />
          <v-btn icon class="la-playButton" @click="playVideo = true">
            <PlayIcon color="#777ff6" />
          </v-btn>
        </div>
        <iframe v-else width="100%" height="316" src="https://www.youtube.com/embed/vo-YF1mERvE?autoplay=1"
          title="YouTube video player" frameborder="0"
          allow="accelerometer; autoplay=1; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen style="border-radius: 23px"></iframe>

        <div class="la-videoTitle">{{ $t('introVideo') }}</div>
      </v-col>
    </div>
    <div class="la-systemTitle">
      {{ $t('landingTitle') }}
    </div>

    <div class="la-infoWrapper">
      <div class="la-infoBlock">
        <div class="la-info">
          <ChatIcon />
          <p class="la-infoText">{{ $t('landingListItem1') }}</p>
        </div>
        <div class="la-info">
          <TimeIcon />
          <span class="la-line"></span>
          <p class="la-infoText">{{ $t('landingListItem2') }}</p>
        </div>
        <div class="la-info">
          <LocationIcon />
          <span class="la-line"></span>
          <p class="la-infoText">{{ $t('landingListItem3') }}</p>
        </div>
      </div>
      <div class="la-infoBlock">
        <div class="la-info">
          <SmileIcon />
          <span class="la-line la-line-none"></span>
          <p class="la-infoText">{{ $t('landingListItem4') }}</p>
        </div>
        <div class="la-info">
          <CheckIcon />
          <span class="la-line"></span>
          <p class="la-infoText">{{ $t('landingListItem5') }}</p>
        </div>
        <div class="la-info">
          <VolumeIcon />
          <span class="la-line"></span>
          <p class="la-infoText">{{ $t('landingListItem6') }}</p>
        </div>
      </div>
    </div>
    <!-- Нэмэлт боломжууд -->
    <div class="la-additionalWrapper">
      <div class="la-addTitle">{{ $t('addTitle') }}</div>
      <div class="la-addMoreTitle">
        {{ $t('addMoreTitle') }}
      </div>
      <div class="la-instructionWrapper">
        <div class="la-insStep1Wrapper">
          <div class="la-insStepTitle">{{ $t('chooseVoice') }}</div>

          <div class="la-insStepCheckWrapper">
            <div class="la-unChecked"></div>
            {{ $t('femaleVoice') }}
          </div>
          <div class="la-insStepCheckWrapper">
            <div style="height: 17px; margin-right: 16px">
              <CheckDefualtIcon />
            </div>
            {{ $t('maleVoice') }}
          </div>
        </div>
        <div class="la-insStep2Wrapper">
          <div class="la-insStepTitle">{{ $t('insStepTitle1') }}</div>
          <div class="la-insStepCheckWrapper">
            <div class="la-unChecked"></div>
            {{ $t('insStepCheckWrapper1') }}
          </div>
          <div class="la-insStepCheckWrapper">
            <div class="la-unChecked"></div>
            {{ $t('insStepCheckWrapper2') }}
          </div>
          <div class="la-insStepCheckWrapper">
            <div style="height: 17px; margin-right: 16px">
              <CheckDefualtIcon />
            </div>
            {{ $t('insStepCheckWrapper3') }}
          </div>
        </div>
        <div class="la-insStep2Wrapper">
          <div class="la-insStepTitle">{{ $t('insStepTitle3') }}</div>
          <div class="la-insStepCheckWrapper">
            <div class="la-unChecked"></div>
            {{ $t('insStepCheckBackground1') }}
          </div>
          <div class="la-insStepCheckWrapper">
            <div style="height: 17px; margin-right: 16px">
              <CheckDefualtIcon />
            </div>
            {{ $t('insStepCheckBackground2') }}
          </div>
          <div class="la-insStepCheckWrapper">
            <div class="la-unChecked"></div>
            {{ $t('insStepCheckBackground3') }}
          </div>
        </div>
        <div class="la-insStep3Wrapper">
          <div class="la-insStepTitle">{{ $t('insStepTitle1Pitch') }}</div>
          <div class="la-insStepCheckWrapper">
            <div class="la-unChecked"></div>
            {{ $t('insStepCheckWrapper1Pitch') }}
          </div>
          <div class="la-insStepCheckWrapper">
            <div class="la-unChecked"></div>
            {{ $t('insStepCheckWrapper2Pitch') }}
          </div>
          <div class="la-insStepCheckWrapper">
            <div style="height: 17px; margin-right: 16px">
              <CheckDefualtIcon />
            </div>
            {{ $t('insStepCheckWrapper3Pitch') }}
          </div>
        </div>

      </div>
    </div>
    <!-- Та унших завгүй л явна уу -->
    <div class="la-informationFullWrapper">
      <v-btn class="la-priceDemoButton2" @click="focusView">
        {{ $t('priceDemoBtn') }}
        <div style="height: 14px; margin-left: 14px">
          <RightArrowIcon />
        </div>
      </v-btn>
      <div class="la-informationWrapper">
        <div class="la-informationTitle">{{ $t('usedQuestion') }}</div>
        <div class="la-informationDesc">
          {{ $t('informationDesc') }}
        </div>
        <div class="la-useChooseWrapper">
          <div class="la-useWrapper">
            <div class="la-circle">
              <LandEmailIcon :width="18" :height="18" color="#777ff6" />
            </div>
            <div class="la-useText">{{ $t('usedListTitle1') }}</div>
          </div>
          <div class="la-useWrapper">
            <div class="la-circle">
              <LandMsgIcon :width="18" :height="18" color="#777ff6" />
            </div>
            <div class="la-useText">{{ $t('usedListTitle2') }}</div>
          </div>
          <div class="la-useWrapper">
            <div class="la-circle">
              <LandInfoIcon :width="18" :height="18" color="#777ff6" />
            </div>
            <div class="la-useText">
              {{ $t('usedListTitle3') }}
            </div>
          </div>
          <div class="la-useWrapper">
            <div class="la-circle">
              <LandPreIcon :width="18" :height="18" color="#777ff6" />
            </div>
            <div class="la-useText">{{ $t('usedListTitle4') }}</div>
          </div>
          <div class="la-useWrapper">
            <div class="la-circle">
              <LandBookIcon :width="18" :height="18" color="#777ff6" />
            </div>
            <div class="la-useText">{{ $t('usedListTitle5') }}</div>
          </div>
          <div class="la-useWrapper">
            <div class="la-circle">
              <LandHelpIcon :width="18" :height="18" color="#777ff6" />
            </div>
            <div class="la-useText">{{ $t('usedListTitle6') }}</div>
          </div>
          <div class="la-useWrapper">
            <div class="la-circle">
              <LandRecIcon :width="18" :height="18" color="#777ff6" />
            </div>
            <div class="la-useText">{{ $t('usedListTitle7') }}</div>
          </div>
          <div class="la-useWrapper">
            <div class="la-circle">
              <LandSpeakerIcon :width="18" :height="18" color="#777ff6" />
            </div>
            <div class="la-useText">{{ $t('usedListTitle8') }}</div>
          </div>
          <div class="la-useWrapper">
            <div class="la-circle">
              <LandVoiceIcon :width="18" :height="18" color="#777ff6" />
            </div>
            <div class="la-useText">{{ $t('usedListTitle9') }}</div>
          </div>
        </div>
      </div>
    </div>
    <!-- Үнэгүй туршиж үзээрэй -->
    <div class="la-demoFullWrapper" id="demoFocus">
      <div class="la-demoTitle">{{ $t('demoTitle') }}</div>
      <div class="la-demoMoreTitle">
        {{ $t('demoMoreTitle') }}
      </div>
      <DemoSynthesize />
    </div>
    <!-- Гар утсан дээрээ ашиглах боломжтой -->
    <div class="la-suggestWrapper">
      <div class="la-phoneImgWrapper">
        <img style="position: absolute; z-index: 2" src="/assets/mobile.svg" alt="mobileReader" />
        <span class="la-circleBlack"></span>
        <span class="la-circlePurple"></span>
        <span class="la-circle3"></span>
        <span class="la-circleOrange"></span>
      </div>
      <div class="la-suggestInfoWrapper">
        <div class="la-suggestTitle">
          {{ $t('suggestTitle') }}
        </div>
        <div class="la-suggestDesc">
          {{ $t('suggestDesc') }}
        </div>
        <div class="d-flex mt-10">
          <a href="https://apps.apple.com/us/app/chimege-reader/id1501713310" target="_blank">
            <img style="margin-right: 10px; cursor: pointer" src="/assets/appstore.svg" alt="readerAppStore" /></a>
          <a href="https://play.google.com/store/apps/details?id=com.chimege.reader&hl=en&gl=US" target="_blank">
            <img style="cursor: pointer" src="/assets/playstore.svg" alt="readerPlayStore" />
          </a>
        </div>
      </div>
    </div>
    <!-- Үнийн саналтай танилцах -->
    <div class="la-priceFullWrapper">
      <div class="la-priceWrapper">
        <div class="la-priceLeftWrapper">
          <div class="la-priceTitle">{{ $t('readerDescTitle') }}</div>
          <a href="/plan" style="text-decoration: none">
            <v-btn class="la-priceInfoSeenButton">
              {{ $t('priceInfoSeenButton') }}
              <div style="height: 14px; margin-left: 30px">
                <RightArrowIcon />
              </div>
            </v-btn>
          </a>
        </div>
        <div class="la-priceRightWrapper"></div>
        <v-btn class="la-priceDemoButton" @click="focusView">
          {{ $t('priceDemoBtn') }}
          <div style="height: 14px; margin-left: 14px">
            <RightArrowIcon />
          </div>
        </v-btn>
      </div>
    </div>
    <!-- Бидний бусад бүтээгдэхүүнүүд -->
    <div class="la-othersWrapper">
      <div class="la-otherProductionsTitle">{{ $t('otherProductionsTitle') }}</div>
      <div class="la-otherProductionsWrapper">
        <a :href="item.url" target="_blank" v-for="(item, index) in products" :key="item.alt + index">
          <v-btn class="la-otherProductionButton"><img :src="item.src" :alt="item.alt" /></v-btn>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import DemoSynthesize from "../components/DemoSynthesize";
import ChatIcon from "../components/icons/ChatIcon";
import TimeIcon from "../components/icons/TimeIcon";
import LocationIcon from "../components/icons/LocationIcon";
import SmileIcon from "../components/icons/SmileIcon";
import CheckIcon from "../components/icons/CheckCircleIcon";
import VolumeIcon from "../components/icons/VolumeIcon";
import CheckDefualtIcon from "../components/icons/CheckDefaultIcon";
import RightArrowIcon from "../components/icons/RightArrowIcon";
import PlayIcon from "../components/icons/PlayIcon";
import LandEmailIcon from "../components/icons/LandEmailIcon";
import LandMsgIcon from "../components/icons/LandMsgIcon";
import LandInfoIcon from "../components/icons/LandInfoIcon";
import LandPreIcon from "../components/icons/LandPreIcon";
import LandBookIcon from "../components/icons/LandBookIcon";
import LandHelpIcon from "../components/icons/LandHelpIcon";
import LandRecIcon from "../components/icons/LandRecIcon";
import LandSpeakerIcon from "../components/icons/LandSpeakerIcon";
import LandVoiceIcon from "../components/icons/LandVoiceIcon";
export default {
  name: "landingPage",
  components: {
    DemoSynthesize,
    ChatIcon,
    TimeIcon,
    LocationIcon,
    SmileIcon,
    CheckIcon,
    VolumeIcon,
    CheckDefualtIcon,
    RightArrowIcon,
    PlayIcon,
    LandEmailIcon,
    LandMsgIcon,
    LandInfoIcon,
    LandPreIcon,
    LandBookIcon,
    LandHelpIcon,
    LandRecIcon,
    LandSpeakerIcon,
    LandVoiceIcon,
  },
  data() {
    return {
      useList: [
        {
          text: "Цахим шуудан",
          icon: <LandEmailIcon />,
        },
      ],
      products: [
        {
          alt: "chimegeWriter",
          url: "https://writer.chimege.mn",
          src: "/assets/ChimegeWriterFull.svg",
        },
        {
          alt: "chimegeKeyboard",
          url: "https://keyboard.chimege.mn",
          src: "/assets/ChimegeKeyboardFull.svg",
        },
        {
          alt: "chimegeTungaamal",
          url:
            "https://play.google.com/store/apps/details?id=com.bolorsoft.tungaatoli&hl=en&gl=US",
          src: "/assets/ChimegeTungaamalFull.svg",
        },
        {
          alt: "bolorsoftBolortoli",
          url: "http://www.bolor-toli.com/",
          src: "/assets/BolorsoftBolortoliFull.svg",
        },
        {
          alt: "BolorsoftKudos",
          url: "https://kudos.mn",
          src: "/assets/BolorsoftKudosFull.svg",
        },
      ],
      playVideo: false,
      items: [
        {
          title: "featureListTitle1",
          imgUrl: "/assets/process.svg",
        },
        {
          title: "featureListTitle2",
          imgUrl: "/assets/money.svg",
        },
        {
          title: "featureListTitle3",
          imgUrl: "/assets/avtomat.svg",
        },
        {
          title: "featureListTitle4",
          imgUrl: "/assets/robot.svg",
        },
        {
          title: "featureListTitle5",
          imgUrl: "/assets/speaker.svg",
        },
      ],
      usageItems: [
        {
          title: "usedListTitle1",
          icon: "mdi-email-outline",
        },
        {
          title: "usedListTitle2",
          icon: "mdi-message-text-outline",
        },
        {
          title: "usedListTitle3",
          icon: "mdi-newspaper",
        },
        {
          title: "usedListTitle4",
          icon: "mdi-book-open",
        },
        {
          title: "usedListTitle5",
          icon: "mdi-book",
        },
        {
          title: "usedListTitle6",
          icon: "mdi-help",
        },
        {
          title: "usedListTitle7",
          icon: "mdi-play-box-outline",
        },
        {
          title: "usedListTitle8",
          icon: "mdi-speaker",
        },
        {
          title: "usedListTitle9",
          icon: "mdi-alphabetical",
        },
      ],
    };
  },
  methods: {
    focusView() {
      var el = document.getElementById("demoFocus");
      el.scrollIntoView();
    },
  },
};
</script>
<style scoped>
/* .container {
  height: calc(100vh-56px);
} */

.la-flex {
  width: 100% !important;
  flex: 0 0 100%;
}

.la-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  background-color: #ffffff;
}

.la-row-white {
  max-width: 1140px;
  width: 100%;
  padding: 90px 0 90px 0;
}

.la-pageTitle,
.la-suggestTitle,
.la-priceTitle {
  font-size: 40px;
  font-weight: bold;
  line-height: 44px;
  color: #1f2d3d;
  margin-bottom: 10px;
}

.la-pageDesc,
.la-suggestDesc {
  font-size: 16px;
  line-height: 24px;
  font-weight: 500;
  text-align: justify;
  color: #868d96;
}

.la-videoBackground {
  display: flex;
  width: 100%;
  height: 316px;
  border-radius: 23px;
}

.la-playButton {
  background-color: #ffffff !important;
  border-radius: 50%;
  box-shadow: none;
  outline: none;
  height: 50px !important;
  width: 50px !important;
  position: absolute;
  margin: auto;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  transition: all 0.5s ease;
}

.la-videoNone {
  display: none;
}

.la-videoTitle {
  display: flex;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  justify-content: center;
  color: #c2cedb;
}

.la-systemTitle {
  display: flex;
  font-weight: 500;
  font-size: 20px;
  line-height: 23px;
  justify-content: center;
  text-align: center;
  color: #1f2d3d;
  margin-bottom: 40px;
  padding: 0 10px;
}

.la-infoWrapper {
  display: flex;
  max-width: 1140px;
  width: 100%;
  flex-wrap: wrap;
  justify-content: center;
  padding: 0 2%;
  margin-bottom: 100px;
}

.la-info {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 33.3%;
  position: relative;
  padding: 0 10px;
}

.la-infoBlock {
  display: flex;
  width: 50%;
}

.la-infoText {
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  color: #1f2d3d;
  text-align: center;
}

.la-line {
  display: inline-block;
  height: 1px;
  width: 50%;
  position: absolute;
  border-bottom: 2px dashed #cacdfc;
  left: -25%;
  top: 8px;
  z-index: 1;
}

.la-additionalWrapper {
  display: flex;
  flex-direction: column;
  padding: 50px 10px 70px 10px;
  background-color: #f3f1f7;
  width: 100%;
  position: relative;
}

.la-addTitle,
.la-demoTitle {
  font-size: 20px;
  font-weight: 500;
  line-height: 23px;
  text-align: center;
  color: #1f2d3d;
}

.la-addMoreTitle,
.la-demoMoreTitle {
  font-size: 16px;
  line-height: 24px;
  text-align: center;
  margin: 10px 0 20px 0;
}

.la-instructionWrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
}

.la-insStep1Wrapper,
.la-insStep2Wrapper,
.la-insStep3Wrapper {
  display: flex;
  flex-direction: column;
  padding: 20px 18px;
  margin-bottom: 10px;
  border-radius: 9px;
  background-color: #ffffff;
  width: 220px;
  height: 196px;
}

.la-insStep2Wrapper {
  width: 229px;
  margin-right: 25px;
  margin-left: 25px;
  height: 196px;
}

.la-insStep1Wrapper:hover,
.la-insStep2Wrapper:hover,
.la-insStep3Wrapper:hover {
  border: 2px solid #cacdfc;
  transform: scale(1.05);
}

.la-insStepTitle {
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  color: #1f2d3d;
  margin-bottom: 10px;
}

.la-insStepCheckWrapper {
  display: flex;
  align-items: center;
  font-size: 14px;
  line-height: 18px;
  color: #1f2d3d;
  margin: 0 0 5px 10px;
}

.la-fileSupportWrapper {
  display: flex;
  margin-left: 10px;
}

.la-plusThings {
  font-size: 14px;
  font-weight: bold;
  line-height: 24px;
  color: #c2cedb;
}

.la-unChecked {
  width: 17px;
  height: 17px;
  border-radius: 5px;
  border: 1px solid #d3dce6;
  margin-right: 16px;
}

.la-informationFullWrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 44px 10px 0 10px;
  height: 575px;
  align-items: center;
  background: url(/assets/backgroundCover.svg) no-repeat center center;
  background-size: cover;
  background-color: #f3f1f7;
}

.la-informationWrapper {
  display: flex;
  max-width: 1140px;
  width: 100%;
  flex-direction: column;
  align-items: center;
}

.la-informationTitle {
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  color: #ffffff;
}

.la-informationDesc {
  font-size: 16px;
  line-height: 18px;
  text-align: center;
  color: #ffffff;
  margin: 14px 0 28px 0;
}

.la-useChooseWrapper {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  align-items: center;
  justify-content: space-between;
}

.la-useWrapper {
  display: flex;
  align-items: center;
  height: 64px;
  background-color: #ffffff;
  width: 32%;
  border-radius: 9px;
  padding: 0 16px;
  margin-bottom: 20px;
  transition: all 0.5s ease;
}

.la-useWrapper:hover {
  box-shadow: 0 0 20px rgba(60, 72, 88, 0.15) !important;
  transition: all 0.5s ease;
}

.la-circle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  min-width: 32px;
  min-height: 32px;
  background-color: #cacdfc;
  border-radius: 50%;
  margin-right: 16px;
}

.la-useText {
  font-size: 14px;
  line-height: 24px;
  color: #000000;
}

.la-demoFullWrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  background-color: #f3f1f7;
  padding: 46px 10px 92px 10px;
}

.la-suggestWrapper {
  display: flex;
  justify-content: center;
  max-width: 1140px;
  width: 100%;
  padding: 96px 20px;
}

.la-phoneImgWrapper {
  width: 248px !important;
  height: 464px;
  margin-right: 84px;
  position: relative;
}

.la-suggestInfoWrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 20px 0;
}

.la-circleBlack {
  width: 43px;
  height: 43px;
  background-color: #1f2d3d;
  position: absolute;
  top: -18px;
  right: 45px;
  border-radius: 50%;
  z-index: 1;
}

.la-circlePurple {
  width: 51px;
  height: 51px;
  background-color: #777ff6;
  position: absolute;
  top: 30px;
  left: -20px;
  border-radius: 50%;
  z-index: 3;
}

.la-circle3 {
  width: 32px;
  height: 32px;
  background-color: #ffe6e2;
  position: absolute;
  top: 40%;
  left: -10px;
  border-radius: 50%;
  z-index: 1;
}

.la-circleOrange {
  width: 16px;
  height: 16px;
  background-color: #fc573b;
  position: absolute;
  top: 32%;
  right: -15px;
  border-radius: 50%;
  z-index: 1;
}

.la-priceFullWrapper {
  display: flex;
  width: 100%;
  background-color: #f3f1f7;
  justify-content: center;
}

.la-priceWrapper {
  display: flex;
  max-width: 1140px;
  width: 100%;
  padding: 0 10px;
  height: 289px;
  align-items: center;
  position: relative;
}

.la-priceLeftWrapper {
  display: flex;
  flex-direction: column;
  width: 55%;
}

.la-priceRightWrapper {
  display: flex;
  width: 45%;
  height: 100%;
  background: url(/assets/homePage1.png) no-repeat center center;
  background-size: cover;
}

.la-priceInfoSeenButton {
  background-color: #f3f1f7 !important;
  text-transform: initial;
  color: #777ff6;
  border: 2px solid #777ff6;
  border-radius: 8px;
  box-shadow: none;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  margin: 20px 0 10px 0;
  height: 45px !important;
  width: 270px;
  letter-spacing: 0;
  transition: all 0.5s ease;
}

.la-priceInfoSeenButton:hover {
  background-color: #777ff6 !important;
  color: #ffffff;
  transition: all 0.5s ease;
}

.la-priceDemoButton {
  background-color: #777ff6 !important;
  text-transform: initial;
  color: #ffffff;
  border-radius: 25px;
  box-shadow: none;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  height: 45px !important;
  width: 210px;
  letter-spacing: 0;
  text-indent: 0;
  position: absolute;
  left: calc(50% - 105px);
  top: -22px;
}
.la-priceDemoButton2 {
  background-color: #777ff6 !important;
  text-transform: initial;
  color: #ffffff;
  border-radius: 25px;
  box-shadow: 10;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  outline: none;
  height: 45px !important;
  width: 210px;
  letter-spacing: 0;
  text-indent: 0;
  top: -66px;
}

.la-othersWrapper {
  display: flex;
  flex-direction: column;
  max-width: 1140px;
  width: 100%;
  min-height: 312px;
  background-color: #ffffff;
  align-items: center;
  justify-content: center;
  padding: 0 10px;
}

.la-otherProductionsTitle {
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  color: #1f2d3d;
  margin: 20px 0 50px 0;
}

.la-otherProductionsWrapper {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  width: 100%;
}

.la-otherProductionButton {
  background-color: #ffffff !important;
  border: 2px solid #e9e9e9;
  border-radius: 9px;
  box-shadow: none;
  outline: none;
  margin: 10px 20px;
  height: 59px !important;
  width: auto;
}

@media screen and (max-width: 768px) {
  .la-infoWrapper {
    flex-direction: column;
  }

  .la-infoBlock {
    width: 100%;
    margin-bottom: 20px;
  }

  .la-line-none {
    display: none;
  }

  .la-informationFullWrapper {
    height: auto;
    background-image: none;
    background-color: #787ff7;
  }

  .la-useWrapper {
    width: 48%;
  }

  .la-suggestWrapper {
    flex-direction: column;
    align-items: center;
  }

  .la-phoneImgWrapper {
    margin: 0;
  }

  .la-suggestInfoWrapper {
    align-items: center;
  }

  .la-priceRightWrapper {
    display: none;
  }

  .la-priceLeftWrapper {
    align-items: center;
    width: 100%;
  }
}

@media screen and (max-width: 576px) {
  .la-useWrapper {
    width: 100%;
  }
}

@media screen and (max-width: 1264px) {
  .la-flex {
    flex: 0 0 0%;
  }
}
</style>
